export default __webpack_public_path__ + "static/media/search.98a4d527.svg";